import { render, staticRenderFns } from "./ReportComment.vue?vue&type=template&id=43dc5a3d&scoped=true&"
import script from "./ReportComment.vue?vue&type=script&lang=js&"
export * from "./ReportComment.vue?vue&type=script&lang=js&"
import style0 from "./ReportComment.vue?vue&type=style&index=0&id=43dc5a3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dc5a3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43dc5a3d')) {
      api.createRecord('43dc5a3d', component.options)
    } else {
      api.reload('43dc5a3d', component.options)
    }
    module.hot.accept("./ReportComment.vue?vue&type=template&id=43dc5a3d&scoped=true&", function () {
      api.rerender('43dc5a3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/modals/ReportComment.vue"
export default component.exports